import { render, staticRenderFns } from "./GlaxiMenu.vue?vue&type=template&id=7f4ef519&"
import script from "./GlaxiMenu.vue?vue&type=script&lang=js&"
export * from "./GlaxiMenu.vue?vue&type=script&lang=js&"
import style0 from "./GlaxiMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports